import { logger, metrics } from 'lib/slardar-utils'

import { getDomainBlackList, getDomainWhiteList } from './constant'

/* eslint-disable complexity */
export function decodeUriBack(originStr: string): string | null {
  let origin = originStr
  if (!origin) {
    return null
  }
  const blackList = getDomainBlackList()
  // 匹配到黑名单，不进行打点
  if (blackList.some((domain) => origin?.includes?.(`${domain}/`))) {
    return null
  }
  const whiteList = getDomainWhiteList()
  if (!whiteList.some((domain) => origin?.includes?.(`.${domain}/`))) {
    logger.warn(`[motor/pc/view-image] not in domain white list url=${origin}`)
    metrics.counter('tosUri.decode.ignore', { url: origin })
    return null
  }

  /* eslint-disable prefer-destructuring */
  origin = origin.split('?')[0]
  // 原格式，如：https://p3.dcarimg.com/obj/developer-baas/baas/ttcqr5/de057af34f101a4e_1605090421476.png
  const objUrlRegex = /\/obj\/(.*)/

  if (objUrlRegex.test(origin)) {
    const matches = origin.match(objUrlRegex)
    if (matches?.[1]) {
      return matches[1]
    }
  }
  // 遗留的图片格式0，如：https://p3.dcarimg.com/large/1bf6000409257e13550d
  const legacyUrlRegex0 = /\/(?:origin|large|medium|thumb|img)\/([0-9a-f]{9,})/
  if (legacyUrlRegex0.test(origin)) {
    const matches = origin.match(legacyUrlRegex0)
    if (matches?.[1]) {
      return `mosaic-legacy/${matches[1]}`
    }
  }
  // 遗留的图片格式，如：https://p3.dcarimg.com/avatar/100x100/1dd5000048d6334c26b4.png
  const legacyUrlRegex1 = /\d+x\d+\/([0-9a-f]{9,})/
  if (legacyUrlRegex1.test(origin)) {
    const matches = origin.match(legacyUrlRegex1)
    if (matches?.[1]) {
      return `mosaic-legacy/${matches[1]}`
    }
  }

  // 遗留的图片格式2，如：https://p3.dcarimg.com/large/pgc-image/a8c9c8f743174b259f21915df49f19a7
  const legacyUrlRegex2 = /[a-z]+\/([0-9a-z-]+)\/([0-9a-f]{9,})/
  if (legacyUrlRegex2.test(origin)) {
    const matches = origin.match(legacyUrlRegex2)
    if (matches && matches[1] && matches[2]) {
      return `${matches[1]}/${matches[2]}`
    }
  }

  // 遗留图片格式3，'https://p3.dcarimg.com/list/300x196/pgc-image/123432866b864bc295ac12102aaf395f'
  const legacyUrlRegex3 = /list\/\d+x\d+\/([0-9a-z-]+)\/([0-9a-f]{9,})/
  if (legacyUrlRegex3.test(origin)) {
    const matches = origin.match(legacyUrlRegex3)
    if (matches && matches[1] && matches[2]) {
      return `${matches[1]}/${matches[2]}`
    }
  }

  // 常见的图片格式，如：https://p3.dcarimg.com/large/pgc-image/a8c9c8f743174b259f21915df49f19a7
  const normalUrlRegex = /(?:img)\/([0-9a-z-]+)\/([0-9a-zA-Z-]{9,})/
  const matches = origin.match(normalUrlRegex)
  if (matches && matches[1] && matches[2]) {
    return `${matches[1]}/${matches[2]}`
  }
  logger.warn(`[motor/pc/view-image] can not decode url=${origin}`)
  metrics.counter('tosUri.decode.miss', { url: origin })
  return null
}

const prefix =
  'origin|aweme|list|live|large/w480|large/w240|large|medium|thumb|details|img|avatar'
const origin = `(?:(?:https?:)?//[^/]+(?:${getDomainWhiteList().join('|')}))`

export function decodeUri(url: string) {
  if (!url || typeof url !== 'string') {
    return null
  }

  // 带有 x-expires | x-signature 参数的图片不解析
  const authRegex = /[^#?]+\?.*x-(expires|signature)=.+/

  if (authRegex.test(url)) {
    return null
  }

  // obj 前缀表示原图 匹配掉 ?和# 即可
  const objRegex = new RegExp(`${origin}/obj/([^?#]+)`)

  const objUri = url.match(objRegex)?.[1]
  if (objUri) {
    return objUri
  }

  // 其他已知前缀的处理掉前缀和切图参数
  const uriRegex = new RegExp(
    `${origin}/(?:(?:${prefix})/(?:[0-9]+x[0-9]+/)?)?((?:.+/)?(?:[^~?#]+)?(\\.$)?)`
  )

  const uri = url.match(uriRegex)?.[1]

  if (!uri) {
    logger.warn(`[motor/pc/view-image] can not decode url=${url}`)
    metrics.counter('tosUri.decode.miss', { url })
    return null
  }

  // 不带bucket 或者 [四位数字]/[若干数字] 需要额外带上虚拟bucket 格式: mosaic-legacy/<URI>
  const legacyUriRegex = /^([0-9a-zA-Z]+|[0-9]{4}\/[0-9]+)(?:\.[a-zA-Z]+)?$/

  const legacyUri = uri.match(legacyUriRegex)?.[1]

  return legacyUri ? `mosaic-legacy/${legacyUri}` : uri
}
